// each way is drawn, not turned: WebKit drew a turned one 0.9px high
const PATHS = {
  left: 'M5.6324 0.632482C5.6324 0.632482 0.632451 4.31493 0.632441 5.63252C0.632429 6.95012 5.63244 10.6325 5.63244 10.6325',
  right:
    'M0.63252 0.632482C0.63252 0.632482 5.63247 4.31493 5.63248 5.63252C5.63249 6.95012 0.63248 10.6325 0.63248 10.6325',
}

interface IChevronIconProps {
  direction: keyof typeof PATHS
}

export const ChevronIcon = ({ direction }: IChevronIconProps) => (
  <svg
    width='6.265'
    height='11.265'
    viewBox='0 0 6.26492 11.265'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d={PATHS[direction]}
      stroke='black'
      strokeWidth='1.26488'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
